import React from 'react';
import { Generalinfo } from '../components';

export const CrewInfo = ({ dtSTD, airportList, crewList }) => {
    return (
    <div className='cabincrew-page-container'>
      <Generalinfo
        dtSTD={dtSTD}
        airportList={airportList}
        crewList={crewList}
      />
      </div>
    );
};
